module.exports = __webpack_public_path__ + "img/parliament.7d128b69.jpg";